module.exports = __webpack_public_path__ + "media/images/natl-aegis-news1841-red-cross-6aeb38a7b92e8c503d194526cb0033b8.png";